<template>
  <div class="agents-tc_record">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入订单号..."></Input>
        </FormItem>
        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd"
                      :value="datePic"
                      @on-change="changeDate"
                      style="width: 200px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.type"
                  placeholder="订单状态"
                  clearable>
            <Option :value="1">正常</Option>
            <Option :value="0">退款</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem class="f-r">
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportShouru()">导出收入记录</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Modal v-model="tcrecordStatus"
           title="提成明细"
           :loading="loading">
      <Table border
             :columns="tclist"
             :data="tctablelist"
             :loading="dataloading"></Table>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";
export default {
  name: "agents-tc_record",
  data () {
    return {
      id: null, // 页面agentid
      loading: true,
      dataloading: true,
      exportLoading: false,
      title: "",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: "",
        type: "",
        starttime: "",
        endtime: ""
      },
      list: [
        {
          title: "用户",
          key: "agent_uuid",
          width: 350,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "订单号：" + params.row.order_num
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "用户ID：" + params.row.agent_uuid
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "手机号：" +
                (params.row.member != null ? params.row.member.username : "")
              )
            ]);
          }
        },
        {
          title: "订单金额",
          key: "total_prices",
          width: 100
        },
        {
          title: "提成",
          key: "money",
          minWidth: 100,
          render: (h, params) => {
            return h("span", params.row.money);
          }
        },
        {
          title: "来源",
          key: "sorces",
          minWidth: 140,
        },
        {
          title: "状态",
          key: "type",
          minWidth: 80,
          render: (h, params) => {
            return h("span", params.row.type == 1 ? "正常" : "退款");
          }
        },
        {
          title: "时间",
          key: "created_at",
          minWidth: 160
        }
        // {
        //   title: "操作",
        //   key: "action",
        //   minWidth: 120,
        //   align: "left",
        //   fixed: "right",
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Button",
        //         {
        //           style: {},
        //           props: {
        //             type: "primary",
        //             size: "small"
        //           },
        //           on: {
        //             click: () => {
        //               this.recorddetail(params.row.id);
        //             }
        //           }
        //         },
        //         "收入明细"
        //       )
        //     ]);
        //   }
        // }
      ],
      tablelist: [],
      tcrecordStatus: false,
      tclist: [
        {
          title: "名称",
          key: "good_title",
          minWidth: 160
        },
        {
          title: "分成2",
          key: "total_prices",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              (params.row.status == 0 ? "+" : "-") + params.row.to_agenttc
            );
          }
        },
        {
          title: "状态",
          key: "status",
          minWidth: 160,
          render: (h, params) => {
            return h("span", params.row.status == 0 ? "正常" : "退款");
          }
        }
      ],
      tctablelist: []
    };
  },
  created: function () {
    this.id = this.$route.params.id;
    this.getTableList();
    // this.getCateList();
    // this.getSkillList();
    // this.getItemList();
  },
  components: {
    UploadThumb,
    uploadthumbTwo
  },
  watch: {
    "$route.params.id": function (curVal, oldVal) {
      if (curVal) {
        this.id = curVal;
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList: function () {
      this.$api.agents
        .tcrecord({ page: this.pages.page, size: this.pages.size, id: this.id })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 删除
    recorddetail: function (id) {
      this.$api.agents.recorddetail({ id: id }).then(res => {
        if (res.code == 200) {
          this.tctablelist = res.result.ordergood;
          this.$Message.success(res.msg);
          this.tcrecordStatus = true;
        }
      });
    },
    changeDate (val) {
      // this.params.datetime = val;
      console.log(val);
      this.formItem.starttime = val[0];
      this.formItem.endtime = val[1];
    },
    exportShouru () {
      this.exportLoading = true;
      this.$api.agents
        .exportagentShouru({
          id: this.id, //	是	string	代理商UUID
          type: this.formItem.type, //	否	int	0减少1增加
          key: this.formItem.key, //	否	string	订单号
          starttime: this.formItem.starttime, //	否	date	开始时间
          endtime: this.formItem.endtime //	否	date	结束时间
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            // window.location.href = res.result;
          }
          this.exportLoading = false;
        });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      console.log("start", this.formItem);
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        id: this.id, //	是	string	代理商UUID
        type: this.formItem.type, //	否	int	0减少1增加
        key: this.formItem.key, //	否	string	订单号
        page: this.pages.page, //	否	int	页码
        size: this.pages.size, //	否	int	每页返回数量
        starttime: this.formItem.starttime, //	否	date	开始时间
        endtime: this.formItem.endtime //	否	date	结束时间
      };
      this.$api.agents.tcrecord(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          for (var i in this.tablelist) {
            this.tablelist[i].auth_company = this.tablelist[
              i
            ].data.auth_company;
            this.tablelist[i].is_undeline =
              this.tablelist[i].is_undeline == 0 ? "否" : "是";
            this.tablelist[i].cate = this.tablelist[i].cate.name;
          }
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
